<template>
  <div class="spList">
    <div class="tuwenLunbo">
      <div class="pc-slide">
        <div class="view">
          <div class="swiper-container" id="gallery">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in dataList"
                :key="item.ID"
                class="swiper-slide"
              >
                <video id="video1" controls="controls">
                  <source :src="item.FileUrl" type="video/mp4" />
                </video>
                <div class="dust"></div>
                <p class="play position_JuZhong">
                  <img src="../assets/img/play.png" alt="" />
                </p>
              </div>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>
        <div class="preview">
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev arrow arrow-left"></div>
          <div class="swiper-button-next arrow arrow-right"></div>
          <div class="swiper-container swiper-container-thumbs" id="thumbs">
            <div class="swiper-wrapper swiper-wrappers">
              <div
                v-for="(item, index) in dataList"
                :key="item.ID"
                class="swiper-slide"
              >
                <div class="sp_box">
                  <video id="video2" controls="controls">
                    <source :src="item.FileUrl" type="video/mp4" />
                  </video>
                  <!-- <div class="dust"></div> -->
                  <!-- <p class="play position_JuZhong"><img src="../assets/img/pl.png" alt=""></p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import "../assets/css/swiper-bundle.css";
import "../assets/js/swiper-bundle.min.js";
export default {
  name: "spList",
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    moreLink: {
      type: String,
      default: ""
    }
  },
  mounted() {
    var viewSwiper = new Swiper(".view .swiper-container", {
      autoplay: false,
      on: {
        slideChangeTransitionStart: function() {
          updateNavPosition();
        }
      }
    });
    $(".view .arrow-left,.preview .arrow-left").on("click", function(e) {
      e.preventDefault();
      if (viewSwiper.activeIndex == 0) {
        viewSwiper.slideTo(viewSwiper.slides.length - 1, 1000);
        return;
      }
      viewSwiper.slidePrev();
    });
    $(".view .arrow-right,.preview .arrow-right").on("click", function(e) {
      e.preventDefault();
      if (viewSwiper.activeIndex == viewSwiper.slides.length - 1) {
        viewSwiper.slideTo(0, 1000);
        return;
      }
      viewSwiper.slideNext();
    });

    var previewSwiper = new Swiper(".preview .swiper-container", {
      // visibilityFullFit: true,
      spaceBetween: 5,
      slidesPerView: 4,
      allowTouchMove: false,
      autoplay: false,
      on: {
        tap: function() {
          viewSwiper.slideTo(previewSwiper.clickedIndex);
        }
      }
    });
    function updateNavPosition() {
      $(".preview .active-nav").removeClass("active-nav");
      var activeNav = $(".preview .swiper-slide")
        .eq(viewSwiper.activeIndex)
        .addClass("active-nav");
      if (!activeNav.hasClass("swiper-slide-visible")) {
        if (activeNav.index() > previewSwiper.activeIndex) {
          var thumbsPerNav =
            Math.floor(previewSwiper.width / activeNav.width()) - 1;
          previewSwiper.slideTo(activeNav.index() - thumbsPerNav);
        } else {
          previewSwiper.slideTo(activeNav.index());
        }
      }
    }

    //视频事件监听
    $(".swiper-slide").on("click", function() {
      $(this)
        .find(".play")
        .toggle();
      $(this)
        .find(".dust")
        .toggle();
      $(this)
        .find("video")[0]
        .play();
    });
  }
};
</script>

<style>
.tuwenLunbo .view {
  width: 599px;
  height: 456px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(4, 84, 153, 0.75);
  border-radius: 5px;
  margin: 36px auto;
  display: flex;
  position: relative;
}
.view .swiper-container {
  width: 591px;
  margin: 4px;
}
.view .play {
  width: 89px;
  height: 89px;
}
/*.view:hover .arrow{display: block;}*/
.view .arrow {
  display: none;
  position: absolute;
  top: 50%;
  margin-top: -35px;
  width: 36px;
  height: 102px;
  z-index: 10;
}
.view .arrow-left {
  background: url(../assets/img/le.png) no-repeat center;
  left: 10px;
}
.view .arrow-right {
  background: url(../assets/img/ri.png) no-repeat center;
  right: 10px;
}
.preview {
  margin: 0 auto;
  position: relative;
  width: 1100px;
}
.preview .swiper-wrapper {
  align-items: center;
}
.preview .swiper-container {
  width: 980px;
  overflow: hidden;
  margin: 0 auto;
  height: 177px;
}
.preview .swiper-slide {
  width: 224px !important;
  height: 170px;
  background-color: #fff;
  box-shadow: 0px 0px 3px 0px rgba(4, 84, 153, 0.75);
  border-radius: 5px !important;
  margin: 0 15px;
  cursor: pointer;
}
.preview .swiper-slide .sp_box {
  width: 218px;
  height: 164px;
  margin: 3px;
}
.preview .arrow {
  position: absolute;
  top: 22%;
  width: 21px;
  height: 144px;
  z-index: 10;
}
.preview .play {
  width: 53px;
  height: 53px;
}
.preview .arrow-left {
  background: url(../assets/img/le.png) no-repeat center;
  left: 0;
}
.preview .arrow-right {
  background: url(../assets/img/ri.png) no-repeat center;
  right: 0;
}
/*.preview .active-nav img {padding: 0;border: 1px solid #0376be;}*/
.preview .swiper-slide {
  opacity: 0.5;
}
.preview .swiper-slide-active {
  /* opacity: 1; */
}
.preview .swiper-slide-thumb-active,
.preview .active-nav {
  opacity: 1;
  box-shadow: 0px 0px 8px 0px rgba(0, 137, 255, 0.75);
}
.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  display: none;
}
.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/spList.vue